import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import axios from 'axios';
import '../styles/Blank.css';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false },
  },
  scales: {
    x: { display: false },
    y: { display: false },
  },
};

const generateGraphData = (count) => ({
  labels: Array.from({ length: count }, (_, i) => ` ${i + 1}`),
  datasets: [
    {
      label: 'Data',
      data: Array(count)
        .fill()
        .map(() => Math.floor(Math.random() * 200)),
      borderColor: '#3b82f6',
      fill: true,
      tension: 0.7,
      pointRadius: 0,
    },
  ],
});

const RecordBox = ({ title, count }) => (
  <div className="box">
    <div className="content">
      <h3 className="title">
        <span className="number">{count} |</span> {title}
      </h3>
    </div>
    <div className="line-graph-container">
      <Line data={generateGraphData(count)} options={chartOptions} />
    </div>
  </div>
);

const Summary = () => {
  const [recordStates, setRecordStates] = useState({});
  const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });

  const fetchSummary = async (startDate, endDate) => {
    try {
      const response = await axios.post('https://chaman.gob.pk/eac_backend/summary.php', {
        startDate,
        endDate,
      });
      setRecordStates(response.data);
    } catch (err) {
      console.error('Failed to fetch summary data:', err);
    }
  };

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    fetchSummary(today, today);
  }, []);

  const handleDateRangeSubmit = (e) => {
    e.preventDefault();
    if (dateRange.startDate && dateRange.endDate) {
      fetchSummary(dateRange.startDate, dateRange.endDate);
    } else {
      alert('Please select both start and end dates.');
    }
  };

  return (
    <div className="blank-content">
      <div className="header">
        <form onSubmit={handleDateRangeSubmit}>
          <label>
            Start Date:
            <input
              type="date"
              value={dateRange.startDate}
              onChange={(e) =>
                setDateRange((prev) => ({ ...prev, startDate: e.target.value }))
              }
            />
          </label>
          <label>
            End Date:
            <input
              type="date"
              value={dateRange.endDate}
              onChange={(e) =>
                setDateRange((prev) => ({ ...prev, endDate: e.target.value }))
              }
            />
          </label>
          <button type="submit">Fetch Summary</button>
        </form>
      </div>
      <div className="body">
        {Object.entries(recordStates).map(([title, count], index) => (
          <RecordBox key={index} title={title} count={count} />
        ))}
      </div>
    </div>
  );
};

export default Summary;
